
const Config = {
    DATA_API_URL: "https://o83zmxegge.execute-api.us-east-1.amazonaws.com/v1/",
    GA_TRACKING_ID: "UA-211569826-1"
}

export default Config